import axios from 'axios'

const state = {
  deviceStatus: {
    total: 0,
    online: 0,
    offline: 0,
    devices: []
  },
  attendanceStats: {
    totalToday: 0,
    byLocation: []
  },
  absentList: [],
  lateList: []
}

const getters = {
  deviceStatusSummary: state => state.deviceStatus,
  onlineDevicesPercentage: state => {
    return state.deviceStatus.total > 0 
      ? (state.deviceStatus.online / state.deviceStatus.total * 100).toFixed(1)
      : 0
  },
  attendanceByLocation: state => state.attendanceStats.byLocation,
  totalAttendanceToday: state => state.attendanceStats.totalToday,
  absentEmployees: state => state.absentList,
  lateEmployees: state => state.lateList
}

const actions = {
  // Lấy trạng thái thiết bị
  async fetchDeviceStatus({ commit }) {
    try {
      const response = await axios.get('/dashboard/device-status')
      commit('setDeviceStatus', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy trạng thái thiết bị:', error)
      throw error
    }
  },

  // Lấy thống kê chấm công
  async fetchAttendanceStats({ commit }) {
    try {
      const response = await axios.get('/dashboard/attendance-stats')
      commit('setAttendanceStats', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy thống kê chấm công:', error)
      throw error
    }
  },

  // Lấy danh sách vắng mặt
  async fetchAbsentList({ commit }) {
    try {
      const response = await axios.get('/dashboard/absent-list')
      commit('setAbsentList', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy danh sách vắng mặt:', error)
      throw error
    }
  },

  // Lấy danh sách đi trễ
  async fetchLateList({ commit }) {
    try {
      const response = await axios.get('/dashboard/late-list')
      commit('setLateList', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy danh sách đi trễ:', error)
      throw error
    }
  },

  // Lấy tất cả dữ liệu dashboard
  async fetchAllDashboardData({ dispatch }) {
    try {
      await Promise.all([
        dispatch('fetchDeviceStatus'),
        dispatch('fetchAttendanceStats'),
        dispatch('fetchAbsentList'),
        dispatch('fetchLateList')
      ])
    } catch (error) {
      console.error('Lỗi khi lấy dữ liệu dashboard:', error)
      throw error
    }
  }
}

const mutations = {
  setDeviceStatus(state, data) {
    state.deviceStatus = data
  },
  setAttendanceStats(state, data) {
    state.attendanceStats = data
  },
  setAbsentList(state, data) {
    state.absentList = data
  },
  setLateList(state, data) {
    state.lateList = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}